'use client';
import { useCallback, useEffect } from "react";
import { useSearchParams, useRouter, usePathname } from "next/navigation";
import * as NProgress from "nprogress";

export default function useUrlQuery() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const path = usePathname();

  const createQueryString = useCallback(
    (key: string, value: string | null) => {
      const params = new URLSearchParams(searchParams);
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
      return params.toString();
    },
    [searchParams]
  );

  const changeUrlQuery = useCallback(
    (key: string, value: string | null) => {
      NProgress.start();

      router.push(path + `?${createQueryString(key, value)}`);
    },
    [router, path, createQueryString]
  );

  const createQueryObj = useCallback(
    (data: Record<string, string | null>) => {
      const params = new URLSearchParams(searchParams);
      for (const key in data) {
        const value = data[key];
        if (value) {
          params.set(key, value);
        } else {
          params.delete(key);
        }
      }

      return params.toString();
    },
    [searchParams]
  );

  const changeUrlQueryObj = useCallback(
    (data: Record<string, string | null>) => {
      NProgress.start();

      router.push(path + `?${createQueryObj(data)}`);
    },
    [router, path, createQueryObj]
  );

  useEffect(() => {
    NProgress.done();
  }, [searchParams]);

  return {
    createQueryString,
    changeUrlQuery,
    createQueryObj,
    changeUrlQueryObj,
  };
}
